import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { OrderStatusRecord } from '@/services/reparoly/catalogApi';

export type OrderStatusesState = {
  items: OrderStatusRecord[];
  lastFetchedAt: string | null;
};

const initialState: OrderStatusesState = {
  items: [],
  lastFetchedAt: null,
};

const orderStatusesSlice = createSlice({
  name: 'orderStatuses',
  initialState,
  reducers: {
    setOrderStatuses(
      state,
      action: PayloadAction<{ items: OrderStatusRecord[]; fetchedAt?: string }>,
    ) {
      state.items = action.payload.items || [];
      state.lastFetchedAt = action.payload.fetchedAt || new Date().toISOString();
    },
    resetOrderStatuses: () => initialState,
  },
});

export const { setOrderStatuses, resetOrderStatuses } = orderStatusesSlice.actions;
export default orderStatusesSlice.reducer;
